var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    [
      _c(
        "emd-card-header",
        [
          _c("emd-text", { attrs: { size: "section" } }, [
            _vm._v(" " + _vm._s(_vm.$t("header"))),
          ]),
        ],
        1
      ),
      _c(
        "emd-card-content",
        [
          _c(
            "emd-text-section",
            [
              _vm.data.planId
                ? _c(
                    "emd-text-content",
                    { attrs: { title: _vm.$t("planId") } },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "emd-color__url",
                          attrs: {
                            tag: "a",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            to: {
                              name: "plansDetail",
                              params: {
                                id: _vm.data.planId,
                                tab: "info",
                              },
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.data.planId) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "emd-text-content",
                { attrs: { title: _vm.$t("expirationDate") } },
                [
                  _vm.data.expirationDate
                    ? _c("span", [_vm._v(_vm._s(_vm.data.expirationDate))])
                    : _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("expirationDateFallback")) + " "
                        ),
                      ]),
                ]
              ),
              _c("emd-text-content", {
                attrs: {
                  title: _vm.$t("shippingCost"),
                  content: _vm.data.shippingCost,
                },
              }),
              _c(
                "emd-text-content",
                { attrs: { title: _vm.$t("totalPaidSessions") } },
                [
                  _vm.data.maxPaidSessions
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("totalPaidSession-content", [
                                _vm.data.totalPaidSessions,
                                _vm.data.maxPaidSessions,
                              ])
                            ) +
                            " "
                        ),
                      ])
                    : _c("span", [
                        _vm._v(" " + _vm._s(_vm.data.totalPaidSessions) + " "),
                      ]),
                ]
              ),
            ],
            1
          ),
          _vm.data.link.name
            ? _c(
                "emd-text-section",
                { attrs: { title: _vm.$t("specificLink") } },
                [
                  _c("emd-text-content", {
                    attrs: {
                      title: _vm.$t("name"),
                      content: _vm.data.link.name,
                    },
                  }),
                  _c("emd-text-content", {
                    attrs: {
                      title: _vm.$t("email"),
                      content: _vm.data.link.email,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "emd-text-section",
            [
              _c("emd-text-content", {
                attrs: {
                  title: _vm.$t("orderCode"),
                  content: _vm.data.orderCode,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }